import { Component } from '@angular/core';

import { BaseCtrlValueAccessorFormComponent } from '@sim/form';
import { UBF } from '@src/app/core/models/cards/card-f';

@Component({
  selector: 'app-ubf-form',
  styleUrls: ['./ubf-form.component.scss'],
  templateUrl: './ubf-form.component.html',
})
export class UbfFormComponent extends BaseCtrlValueAccessorFormComponent<UBF> {

  constructor() {
    super();
  }

}
